import ArrowSvg from "./ArrowSvg";
import CalculateSvg from "./CalculateSvg";
import DateSvg from "./DateSvg";
import EyeSvg from "./EyeSvg";
import PencilSvg from "./PencilSvg";
import PlusSvg from "./PlusSvg";

export const OfficeAccountingSvgExport = {
  ArrowSvg,
  CalculateSvg,
  DateSvg,
  EyeSvg,
  PencilSvg,
  PlusSvg,
};
